// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary-container {
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
}

.error-boundary-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1.5px 4px rgba(131, 127, 57, 0.1);
  padding: 2.5rem 2rem 2rem 2rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
  font-family: "Poppins", "Segoe UI", Arial, sans-serif;
}

.error-boundary-icon {
  background: #fffbe6;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem auto;
  box-shadow: 0 2px 8px rgba(131, 127, 57, 0.1);
}

.error-boundary-svg {
  width: 36px;
  height: 36px;
  color: #d97706;
}

.error-boundary-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.5rem;
}

.error-boundary-message {
  color: #555;
  font-size: 1rem;
  margin-bottom: 2rem;
}

.error-boundary-empid {
  color: #836f39;
  font-weight: 500;
  background: #f6e9c6;
  border-radius: 6px;
  padding: 0.1em 0.5em;
  font-size: 0.98em;
}

.error-boundary-logout-btn {
  background: rgb(131, 127, 57);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.75em 2em;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(131, 127, 57, 0.1);
}

.error-boundary-logout-btn:hover {
  background: linear-gradient(90deg, #bfae4a 0%, #837f39 100%);
}`, "",{"version":3,"sources":["webpack://./src/layout/ErrorBoundary/ErrorBoundary.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,+EAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,qDAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,6CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,6CAAA;AACF;;AAEA;EACE,4DAAA;AACF","sourcesContent":[".error-boundary-container {\n  min-height: 90vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8fafc;\n}\n\n.error-boundary-card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.08), 0 1.5px 4px rgba(131,127,57,0.10);\n  padding: 2.5rem 2rem 2rem 2rem;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;\n}\n\n.error-boundary-icon {\n  background: #fffbe6;\n  border-radius: 50%;\n  width: 64px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5rem auto;\n  box-shadow: 0 2px 8px rgba(131,127,57,0.10);\n}\n\n.error-boundary-svg {\n  width: 36px;\n  height: 36px;\n  color: #d97706;\n}\n\n.error-boundary-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 0.5rem;\n}\n\n.error-boundary-message {\n  color: #555;\n  font-size: 1rem;\n  margin-bottom: 2rem;\n}\n\n.error-boundary-empid {\n  color: #836f39;\n  font-weight: 500;\n  background: #f6e9c6;\n  border-radius: 6px;\n  padding: 0.1em 0.5em;\n  font-size: 0.98em;\n}\n\n.error-boundary-logout-btn {\n  background: rgb(131, 127, 57);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75em 2em;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  box-shadow: 0 2px 8px rgba(131,127,57,0.10);\n}\n\n.error-boundary-logout-btn:hover {\n  background: linear-gradient(90deg, #bfae4a 0%, #837f39 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
